/*
 * One vocabulary for semantic colour across alerts, snackbars, badges and
 * buttons, so a "warning" looks the same wherever it is raised.
 */
export enum Tone {
  Default = "default",
  Success = "success",
  Warning = "warning",
  Destructive = "destructive",
}

export const toneOrder: Tone[] = [
  Tone.Default,
  Tone.Success,
  Tone.Warning,
  Tone.Destructive,
];

/* Surface: a tinted background with a matching border and text colour. */
export const toneSurface: Record<Tone, string> = {
  [Tone.Default]: "border-border bg-muted text-foreground",
  [Tone.Success]: "border-success/30 bg-success/5 text-success",
  [Tone.Warning]: "border-warning/30 bg-warning/5 text-warning",
  [Tone.Destructive]: "border-destructive/30 bg-destructive/5 text-destructive",
};

/* Same colours over an opaque background, for chrome that floats over content. */
export const toneTint: Record<Tone, string> = {
  [Tone.Default]: "bg-muted",
  [Tone.Success]: "bg-success/5",
  [Tone.Warning]: "bg-warning/5",
  [Tone.Destructive]: "bg-destructive/5",
};

export const toneBorder: Record<Tone, string> = {
  [Tone.Default]: "border-border",
  [Tone.Success]: "border-success/30",
  [Tone.Warning]: "border-warning/30",
  [Tone.Destructive]: "border-destructive/30",
};

export const toneText: Record<Tone, string> = {
  [Tone.Default]: "text-foreground",
  [Tone.Success]: "text-success",
  [Tone.Warning]: "text-warning",
  [Tone.Destructive]: "text-destructive",
};

export const toneProgress: Record<Tone, { track: string; fill: string }> = {
  [Tone.Default]: { track: "bg-foreground/10", fill: "bg-foreground/40" },
  [Tone.Success]: { track: "bg-success/15", fill: "bg-success/60" },
  [Tone.Warning]: { track: "bg-warning/15", fill: "bg-warning/60" },
  [Tone.Destructive]: {
    track: "bg-destructive/15",
    fill: "bg-destructive/60",
  },
};
